module.exports = __webpack_public_path__ + "img/security.bc623f82.svg";